import React from 'react';
import PropTypes from 'prop-types';
import {withRouter, Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {getSelectedPrimaryAccount, hasDeposits} from "../invoice/Selectors";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {clearSelectedInvoices, updatePrimaryAccount} from "../../actions/InvoiceActions";
import {ACCOUNT_PAYER_ALL} from "../../constants/ApplicationConstants";
import {Logout} from "../../actions/UserActions";
import {
  canEditSystemConfig,
  canManagePaymentMethods,
  canManageRegistrationRequests,
  canManageUsers, canViewUsers
} from "../../PermissionSelectors";

class MenuDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAccounts: false, 
    };
    
    this.toggleShowAccounts = this.toggleShowAccounts.bind(this);
    this.onAccountSelect = this.onAccountSelect.bind(this);
    this.logout = this.logout.bind(this);
  }
  
  toggleShowAccounts(){
    this.setState({showAccounts: !this.state.showAccounts}) 
  }
  
  logout() {
    Logout(this.props.dispatch);
  };
  
  onAccountSelect(i) {
    clearSelectedInvoices(this.props.dispatch);
    updatePrimaryAccount(this.props.dispatch, i, this.props.accountType !== ACCOUNT_PAYER_ALL);
    this.props.onClose();
  }

  render() {
    return (<div>
      <div className="cnbs-menu-drawer" style={{minWidth: "199px"}}>
        <List component="nav">
          <ListSubheader disableSticky={true}>Account</ListSubheader>
          <ListItem button onClick={this.toggleShowAccounts}>
            <ListItemText primary={this.props.selectedPrimaryAccount && (this.props.selectedPrimaryAccount.Name)}
                          secondary={this.props.selectedPrimaryAccount && (this.props.selectedPrimaryAccount.PrimaryAcct)}/>
            {this.state.showAccounts ? <ExpandLess/> : <ExpandMore/>}
          </ListItem>
        </List>
        {this.state.showAccounts && <React.Fragment>
          <Divider/>
          <List component="nav">
            {this.props.primaryAccounts.map((account, index) => {
              return (<ListItem button key={account.PrimaryAcct} onClick={() => {
                this.onAccountSelect(index); 
              }}>
                <ListItemText primary={account.Name}
                              secondary={account.PrimaryAcct}/>
              </ListItem>)
            })}
          </List>
        </React.Fragment>}
        {!this.state.showAccounts && <React.Fragment>
          <Divider/>
          <List component="nav">
            <ListItem button component={Link} to={'/invoices'} onClick={this.props.onClose}>
              <ListItemText primary="Invoices"/>
            </ListItem>
            {this.props.hasDeposits && <ListItem button component={Link} to={'/deposits'} onClick={this.props.onClose}>
              <ListItemText primary="Deposits"/>
            </ListItem>}
          </List>
          <Divider/>
          <List component="nav">
            <ListSubheader>Settings</ListSubheader>
            <ListItem button component={Link} to={'/settings/profile'} onClick={this.props.onClose}>
              <ListItemText primary="Account"/>
            </ListItem>
            {this.props.canViewUsers && <ListItem button component={Link} to={'/settings/users'} onClick={this.props.onClose}>
              <ListItemText primary="User Management"/>
            </ListItem>}
            {/* TODO SCHINDLER SPECIFIC */}
            {/*{this.props.canManageRegistrationRequests && <ListItem button component={Link} to={'/settings/registration-requests'} onClick={this.props.onClose}>*/}
              {/*<ListItemText primary="Registration Request"/>*/}
            {/*</ListItem>}*/}
            {this.props.canEditSystemConfig && <ListItem button component={Link} to={'/settings/configuration'} onClick={this.props.onClose}>
              <ListItemText primary="Configuration"/>
            </ListItem>}
            {this.props.canManagePaymentMethods && <ListItem button component={Link} to={'/settings/payment-methods'} onClick={this.props.onClose}>
              <ListItemText primary="Payment Methods"/>
            </ListItem>}
          </List>
          <Divider/>
          <List component="nav">
            <ListItem button component={Link} to={"/help"} onClick={this.props.onClose}>
              <ListItemText primary="Help"/>
            </ListItem>
            <ListItem button onClick={this.logout}>
              <ListItemText primary="Logout"/>
            </ListItem>
          </List>
        </React.Fragment>}
      </div>
    </div>)
  }
}

MenuDrawer.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default withRouter(connect((state, props) => ({
  accountType: state.user_options.accountType,
  canEditSystemConfig: canEditSystemConfig(state, props),
  canManagePaymentMethods: canManagePaymentMethods(state, props),
  canManageRegistrationRequests: canManageRegistrationRequests(state, props),
  canManageUsers: canManageUsers(state, props),
  canViewUsers: canViewUsers(state, props),
  currentUser: state.default.currentUser,
  hasDeposits: hasDeposits(state, props),
  primaryAccounts: state.user_options.primaryAccounts,
  selectedPrimaryAccount: getSelectedPrimaryAccount(state, props)
}))(MenuDrawer));
